import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from 'components/system/Paper';
import Page from 'components/system/Page';
import colors from 'styles/colors';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Page sx={{ height: 'calc(100% - 90px)' }}>
      <Paper sx={{ height: '100%', marginTop: '40px' }}>
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            width: '100%',
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box>
            <Typography variant="h5" color={colors.text.primary}>
              Page Not Found
            </Typography>
            <Typography variant="body2" sx={{ color: colors.text.tetriary, padding: '20px 0' }}>
              Sorry, we couldn’t find the page you’re looking for.
            </Typography>
            <Button type="primary" variant="contained" onClick={() => navigate('/')}>
              Back to Home
            </Button>
          </Box>
        </Box>
      </Paper>
    </Page>
  );
};

export default PageNotFound;
